import styled from '@emotion/styled'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import AccessibleAiImage from './AccessibleAiImage'

const copy = {
  heading: `Use AI to turn every customer interaction into a unique customer experience`,
  description: `Segment makes it easier than ever to understand, predict, generate, and engage each individual customer in real-time and at scale.`,
}

const link = {
  text: `Learn more`,
  href: `/solutions/ai/`,
}

const AccessibleAi = () => {
  const pageConfig = usePageConfig()
  return (
    <SectionBase variant="2Col">
      <SectionCopy alignSelf="center">
        <CopyTextBase>
          <CopyText.Heading tag="h2">{copy.heading}</CopyText.Heading>
          <CopyText.Description variant="pLarge" tag="p">
            {copy.description}
          </CopyText.Description>
          <CopyText.Link href={getAbsoluteUrl(link.href, pageConfig)}>{link.text}</CopyText.Link>
        </CopyTextBase>
      </SectionCopy>
      <Section.Contents>
        <AccessibleAiImage />
      </Section.Contents>
    </SectionBase>
  )
}

const SectionCopy = styled(Section.Copy)`
  max-width: 440px;
`

export default AccessibleAi
